import { render } from "./vendor-form.vue?vue&type=template&id=07ccc64e"
import script from "./vendor-form.vue?vue&type=script&lang=js"
export * from "./vendor-form.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__